import React from 'react';

/** SEO prose — source: mockup L569–589. */
const SeoProse = (): React.JSX.Element => (
  <section className="oq-seo">
    <div className="oq-container oq-seo__inner">
      <h2 className="oq-seo__title oq-bebas">
        A sports club app, booking system and membership management platform in one
      </h2>
      <div className="oq-seo__grid">
        <div>
          <h3 className="oq-seo__block-title oq-bebas">
            The sports club app members open every week
          </h3>
          <p className="oq-seo__block-body">
            Olympiq is a fast, modern <b>sports club app</b> for iOS and Android — sessions,
            club champs, messaging and payments in one place — for members, coaches and admins alike.
          </p>
        </div>
        <div>
          <h3 className="oq-seo__block-title oq-bebas">
            A sports booking app built for training
          </h3>
          <p className="oq-seo__block-body">
            As a <b>sports booking app</b>, Olympiq handles recurring sessions, capped places
            and paid bookings with Apple Pay and Google Pay. Coaches see live registers; members
            book in two taps.
          </p>
        </div>
        <div>
          <h3 className="oq-seo__block-title oq-bebas">
            A membership management system that chases subs
          </h3>
          <p className="oq-seo__block-body">
            As a <b>membership management system</b>, Olympiq runs rolling 12-month memberships
            — trials handled, subs collected, unpaid accounts frozen — so your committee spends
            less time on admin.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default SeoProse;
